<template>
  <div class="cert-list">
    <p style="margin-bottom: 15px;">由 <span style="font-weight: 700">{{companyStr}}</span> 生产的 <i style="font-weight: 700">{{certList.length}}</i> 张型号证书如下：<a-button style="float: right" size="small" type="link" icon="rollback" @click="rollback()">返回</a-button></p>
    <div class="table">
        <a-table
            :columns="columns"
            :dataSource="certList"
            :pagination="false"
            :rowKey="r => r.id"
            :loading="loading"
            @expandRowByClick="true">
            <template slot="product" slot-scope="record">
                <a-popover placement="topRight">
                    <template slot="content">
                            <p style="width: 200px;word-wrap: break-word;word-break: break-all;overflow: hidden;" v-if="record.product">{{record.product}}</p>
                    </template>
                        <p class="item-type">{{record.product}}</p>
                </a-popover>
            </template>
            <template slot="modelSpecification" slot-scope="record">
                <a-popover placement="topRight">
                    <template slot="content">
                            <p style="width: 500px;word-wrap: break-word;word-break: break-all;overflow: hidden;" v-if="record.modelSpecification">{{record.modelSpecification}}</p>
                    </template>
                        <p class="item-type" v-if="record.modelSpecification">{{record.modelSpecification}}</p>
                </a-popover>
            </template>
            <template slot="keySum" slot-scope="record">
                <span v-if="record.keySum <= 0">-</span>
                <p v-else style="color:#3385FF;cursor: pointer" @click="setKeyPiece(record)">{{record.keySum}}</p>
            </template>
             <template slot="abnormalNum" slot-scope="record">
                <span v-if="record.abnormalNum <= 0">-</span>
                <p v-else>{{record.abnormalNum}}</p>
            </template>
                <!-- 状态 -->
            <template slot="state" slot-scope="record">
                <common-badge :state="record.state" :text="record.state"></common-badge>
            </template>
        </a-table>
    </div>
    <key-list v-if="isShowDialog" :id="certId" @hideAction="dialogHide"/>
  </div>
</template>
<script>

import { getCertList } from '@/api/provider'
import {formatDate, dateDiff} from '@/utils/date';
import {getFileSuffix,isAssetTypeAnImage,isAssetTypeOther} from '@/utils/index'

import keyList from '@/components/consistency/provider/keyList.vue';

const align = 'center'
export default {
  name: 'certList',
  components: {keyList},
  data() {
    return {
      columns: [
        {
          title: "NO.",
          dataIndex: "No",
          align,
          width: 80,
        },
        {
          title: "证书编号",
          dataIndex: "number",
          align,
          width: 150
        },
        {
          title: "状态",
          scopedSlots: { customRender: 'state' },
          align,
          width:100
        },
        {
          title: "产品名称",
          scopedSlots: { customRender: 'product' },
          align,
          width: 200
        },
        {
          title: "系列型号",
          scopedSlots: { customRender: 'modelSpecification' },
          align,
          width:200
        },
        {
          title: "关键件清单",
          scopedSlots: { customRender: 'keySum' },
          align,
          width: 120
        },
        {
          title: "异常关键件证书",
          scopedSlots: { customRender: 'abnormalNum' },
          align,
          width: 120
        },
      ],
      certList: [],
      loading: true,
      companyStr: '',
      id: '',
      certId: '',
      isShowDialog: false
    }
  },
  mounted() {
    let id = this.$route.query.id;
    this.companyStr = this.$route.query.companyStr;
    this.getCertList(id);
  },
  methods: {
    rollback() {
      this.$router.go(-1);
    },
    dialogHide() {
        this.isShowDialog = false;
    },
    getCertList(id) {
        getCertList(id)
            .then(res => {
                res.map((i, index) => {
                    i.No = index + 1
                })
                this.certList = res;
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
            })
    },
    setKeyPiece(record) {
        this.isShowDialog = true;
        this.certId = record.id;
    }
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    dateDiff(time){
      return dateDiff(time);
    },
    stateVal(val) {
        if (val == '0') {
            return '0'
        } else if (val == '2') {
            return '暂停'
        } else if (val == '3') {
            return '已绑定'
        }
    },
  },
}
</script>

<style lang="less" scoped>
.item-type {
    display: inline-block;
    width: 200px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;
    vertical-align: middle;
    cursor: pointer;
}
.table {
  background: #fff;
  z-index: 1;
}
.cert-list {
    height: 100%;
    background-color: #fff;
    padding: 20px;
}
</style>

